import React, { useState } from 'react';

function YearSelector({onInputChange,formState}) {

  // Genera opciones para los años desde 1900 hasta 2100
  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = 1960; year <= 2100; year++) {
      years.push(year);
    }
    return years.map(year => (
      <option key={year} value={year}>{year}</option>
    ));
  };

  return (
    <div>
      <select 
        className="dateformdet" 
        id="year" 
        name="anioModelo" 
        value={formState.anioModelo} 
        onChange={onInputChange}   
        tabIndex={5}
        required
      >
        <option value="" select disabled>Seleccione el año del modelo de vehículo</option>
        {generateYearOptions()}
      </select>
    </div>
  );
}

export default YearSelector;
